import { inject, Injectable, signal } from '@angular/core';
import { finalize, of, tap } from 'rxjs';
import { MainConfiguration } from '../../models/main-configuration';
import { MainConfigurationService } from '../api/main-configuration.service';

@Injectable({
  providedIn: 'root',
})
export class MainConfigurationSharedService {
  private readonly mainConfigurationService = inject(MainConfigurationService);
  private readonly configuration = signal<MainConfiguration | null>(null);
  private readonly isLoading = signal(false);

  readonly cableSections = signal<readonly number[]>([]);

  loadConfiguration() {
    if (this.configuration() || this.isLoading()) {
      return of(this.configuration());
    }

    this.isLoading.set(true);
    return this.mainConfigurationService.loadConfiguration().pipe(
      tap((config) => {
        this.configuration.set(config);
        const sections = config?.cableSections ?? [];
        this.cableSections.set(sections);
      }),
      finalize(() => this.isLoading.set(false)),
    );
  }
}
